module.exports = __webpack_public_path__ + "static/media/021.a3782ef3.jpg";